/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Redeem_Tree_List2Inputs */

const en_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use stamps to redeem returning trees`)
};

const ar_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم الطوابع لاستبدال الأشجار العائدة`)
};

const de_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende Stempel, um wiederkehrende Bäume einzulösen`)
};

const es_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa sellos para canjear los árboles de regreso`)
};

const fr_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les timbres pour obtenir les arbres de retour`)
};

const it_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i timbri per riscattare gli alberi di ritorno`)
};

const ja_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプを使って復刻樹木と交換できます`)
};

const ko_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프를 사용하여 돌아온 나무를 교환하세요`)
};

const pt_br_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use selos para resgatar as árvores de volta`)
};

const ru_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте штампы, чтобы получить возвращающиеся деревья`)
};

const th_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้แสตมป์เพื่อแลกรับต้นไม้ที่กลับมา`)
};

const tr_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dönen ağaçları almak için pulları kullanın`)
};

const zh_cn_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用印花来兑换返场树种`)
};

const zh_tw_how_to_redeem_tree_list2 = /** @type {(inputs: How_To_Redeem_Tree_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用印花來兌換回歸樹種`)
};

/**
* | output |
* | --- |
* | "Use stamps to redeem returning trees" |
*
* @param {How_To_Redeem_Tree_List2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_to_redeem_tree_list2 = /** @type {((inputs?: How_To_Redeem_Tree_List2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Redeem_Tree_List2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_to_redeem_tree_list2(inputs)
	if (locale === "ar") return ar_how_to_redeem_tree_list2(inputs)
	if (locale === "de") return de_how_to_redeem_tree_list2(inputs)
	if (locale === "es") return es_how_to_redeem_tree_list2(inputs)
	if (locale === "fr") return fr_how_to_redeem_tree_list2(inputs)
	if (locale === "it") return it_how_to_redeem_tree_list2(inputs)
	if (locale === "ja") return ja_how_to_redeem_tree_list2(inputs)
	if (locale === "ko") return ko_how_to_redeem_tree_list2(inputs)
	if (locale === "pt_br") return pt_br_how_to_redeem_tree_list2(inputs)
	if (locale === "ru") return ru_how_to_redeem_tree_list2(inputs)
	if (locale === "th") return th_how_to_redeem_tree_list2(inputs)
	if (locale === "tr") return tr_how_to_redeem_tree_list2(inputs)
	if (locale === "zh_cn") return zh_cn_how_to_redeem_tree_list2(inputs)
	return zh_tw_how_to_redeem_tree_list2(inputs)
});